export default __webpack_public_path__ + "locales/ru/Common.json?hash=92929a82d605fe042b64f5c2e1ffb5e1";